<template>
  <v-card class="horario-batida-card" outlined>
    <v-card-text>
      <div class="d-flex justify-space-between align-start">
        <div class="horario-batida-card__content">
          <div class="text-subtitle-3 font-weight-medium horario-batida-card__text">
            {{ item.data_formatada || item.data }} - {{ item.dia_semana || "Dia" }}
          </div>
          <div class="mt-2 text-body-3 horario-batida-card__text">
            Horário: {{ item.hora_formatada || item.hora }}
          </div>
          <div class="text-body-2 horario-batida-card__text">Status: {{ item.status }}</div>
          <div v-if="item.nsr" class="text-body-2 horario-batida-card__text">
            NSR: {{ item.nsr }}
          </div>
        </div>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="primary"
              :loading="baixandoComprovante"
              v-bind="attrs"
              v-on="on"
              @click="abrirComprovante"
            >
              <v-icon>mdi-download-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>Baixar comprovante</span>
        </v-tooltip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "HorarioBatidaCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      baixandoComprovante: false,
    };
  },
  methods: {
    async abrirComprovante() {
      try {
        this.baixandoComprovante = true;
        await this.$services.instrutorHorariosService.abrirComprovanteBatida(this.item.id);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.baixandoComprovante = false;
      }
    },
  },
};
</script>

<style scoped>
.horario-batida-card {
  border-radius: 8px;
  margin-bottom: 12px;
}

.horario-batida-card__text {
  font-size: 1rem;
}

@media (min-width: 960px) {
  .horario-batida-card__content {
    min-width: 0;
  }

  .horario-batida-card__text {
    display: inline;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .horario-batida-card__text + .horario-batida-card__text {
    margin-left: 12px;
  }

  .horario-batida-card__text.mt-2 {
    margin-top: 0 !important;
  }
}
</style>
